<template>
  <div :class="[className, 'elemSelect']">
    <label :for="fieldId">
      {{ label }}
    </label>
    <select :disabled="disabled" :id="fieldId" v-model="value">
      <option
        v-for="(option, key) in options"
        :key="key"
        :value="option[optionValue]"
      >
        {{ option[optionText] }}
      </option>
    </select>
    <span class="error">{{ error }}</span>
  </div>
</template>

<script>
// Сквозной счётчик, чтобы у каждого поля на странице был свой id
let instanceCount = 0;

export default {
  name: "elemSelect",
  props: {
    optionValue: {
      default: "value",
    },
    optionText: {
      default: "text",
    },
    disabled: {
      default: false,
    },
    elId: {
      default: null,
    },
    label: {
      default: null,
    },
    error: {
      default: null,
    },
    valueName: {
      default: null,
    },
    valueProp: {
      default: null,
    },
    className: {
      default: null,
    },
    options: {
      default: () => [],
    },
  },
  data() {
    return {
      value: null,
      uid: ++instanceCount,
    };
  },
  computed: {
    fieldId() {
      return this.elId || "elemSelect-" + this.uid;
    },
  },
  watch: {
    valueProp(value) {
      this.value = value;
    },
    value(value) {
      this.$emit("changeValue", this.valueName, value);
    },
  },
  methods: {},
  created() {
    this.value = this.valueProp;
  },
};
</script>
